import { useUnsavedChanges } from "aic";
import { BottomNav } from "components/topbar/BottomNav";
import { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { TopBar } from "../components/topbar/TopBar";

/**
 * The server down page
 */
export const ServerDownPage = (): React.ReactElement => {
  const maintenanceCassette = new URL("../../public/maintenance-cassette.jpg", import.meta.url);
  const { clearUnsavedChanges } = useUnsavedChanges("server-down-page");
  useEffect(() => {
    clearUnsavedChanges();
  }, [clearUnsavedChanges]);

  return (
    <>
      <TopBar
        title="Server unavailable"
        showUser={false}
      />
      <Container>
        <Row>
          <Col
            className="d-flex justify-content-center"
            xs={{ offset: 2, span: 4 }}
          >
            <img
              src={maintenanceCassette.href}
              alt="Server unavailable"
              title="Server unavailable"
              width="400"
              height="300"
            />
          </Col>
          <Col
            xs={4}
            className="d-flex justify-content-center align-items-center"
          >
            <h5>
              <div>Sorry, the MOSAIC&nbsp;Biometrics server is not responding</div>
              <div>Try again later</div>
              <div className="d-flex justify-content-center mt-3">{"\u2639"}</div>
            </h5>
          </Col>
        </Row>
      </Container>
      <BottomNav />
    </>
  );
};

ServerDownPage.displayName = "ServerDownPage";

export default ServerDownPage;
